import { render, staticRenderFns } from "./BpDropdown.vue?vue&type=template&id=42b1cfdc&"
import script from "./BpDropdown.vue?vue&type=script&lang=js&"
export * from "./BpDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BpDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports